import { FC } from 'react';

import { IconButton } from '@components/button/Button';
import { Tooltip } from '@components/index';

interface ActionButtonProps {
  item: any;
  handleEditAction?: (item: any) => void;
  handleDownloadAction?: (item: any) => void;
  handleDeleteAction?: (item: any) => void;
  actions: string[]; // edit, download, delete
}

const ActionButton: FC<ActionButtonProps> = ({
  item,
  handleEditAction,
  handleDownloadAction,
  handleDeleteAction,
  actions
}) => {
  const handleOptionSelect = (e: React.MouseEvent, option: string) => {
    e.stopPropagation();
    switch (option) {
      case 'edit':
        handleEditAction?.(item);
        break;
      case 'download':
        handleDownloadAction?.(item);
        break;
      case 'delete':
        handleDeleteAction?.(item);
        break;
      default:
        break;
    }
  };

  const moreOptions = [
    {
      id: 'edit',
      label: 'Edit',
      iconName: 'edit'
    },
    {
      id: 'download',
      label: 'Download',
      iconName: 'download'
    },
    {
      id: 'delete',
      label: 'Delete',
      iconName: 'trash',
      style: 'text-error'
    }
  ];

  const options = moreOptions.filter((option) => actions.includes(option.id));

  return (
    <div className="flex items-center gap-2">
      {options.map((option) => (
        <>
          <IconButton
            key={option.id}
            iconName={option.iconName}
            variant="transparent"
            size="none"
            className="!p-1"
            iconSize="16"
            handleClick={(e) => handleOptionSelect(e, option.id)}
            data-tooltip-id={`${option.id}-icon-${item.id}`}
          />
          <Tooltip
            id={`${option.id}-icon-${item.id}`}
            type="text"
            tooltipText={option.label}
          />
        </>
      ))}
    </div>
  );
};

export default ActionButton;
